import React, { useState } from 'react';

import eventBus from 'EventBus';
import CommonModal from '../../Common/CommonModal';
import ConfirmModal from '../../Common/ConfirmModal';
import MobileWizard from '../WizardDataLoader';

import { toast } from '../../Common/ToastNotification';

//Legacy code
import mobileService from '../../../service/mobile/MobileService';
import listService from 'ListService';
import userService from "UserService";
import mobileConstants from '../../../mobile/commons/MobileFormsConstants';

const openWizard = (openWizardFx, options = {}) => {

    const { fromLeftPanel = false } = options;

    if (openWizardFx) {
        const isMobileWizardCompleted = listService.mobileGetWizardCompleted;
        const hasNewObjects = mobileService.designerHasNewObjects();

        if (!isMobileWizardCompleted || fromLeftPanel || hasNewObjects) {
            openWizardFx();
        } else {
            listService.linkClicked = true;
            Backbone.history.loadUrl('mobile');
            eventBus.trigger('changeMobileLayout');
        }
    }

}

export const useWizardLauncher = () => {
    const [confirmModalProps, setConfirmModalProps] = useState(null);

    const launchWizard = async (options = {}) => {

        const { fromLeftPanel = false } = options;

        const openWizardFn = () => {
            CommonModal.open(MobileWizard, {
                modalProps: { headerTitle: 'Mobile App Wizard' },
                componentProps: { fromLeftPanel }
            });
        };

        if (!userService.checkFeatures(mobileConstants.MOBILE_ACCOUNT_VIEW)) {
            const alertConfig = mobileConstants.MOBILE_ACCOUNT_MESSAGE.get("noMobileDesign");
            setConfirmModalProps({
                title: alertConfig.header,
                children: alertConfig.content,
                onClose: () => setConfirmModalProps(null),
                buttons: [{ label: 'OK', variant: 'gray', onClick: () => setConfirmModalProps(null) }],
            });
            return;
        }

        if (listService.isDirty || listService.isMobileDirty) {
            try {
                const successMsg = await mobileService.saveApp();
                
                toast.show({ type: 'success', message: successMsg });
                openWizard(openWizardFn, { fromLeftPanel });
            } catch (errorInfo) {
                if(errorInfo !== 0){
                    toast.show({ type: 'error', message: errorInfo[0] || 'An unknown error occurred.' })
                }
            }
        } else {
            openWizard(openWizardFn);
        }
    };

    // Return the launcher function and the JSX for the modal to be rendered
    const ConfirmModalComponent = confirmModalProps ? <ConfirmModal {...confirmModalProps} /> : null;

    return { launchWizard, ConfirmModalComponent };
};